import { ENQ_STATUS } from "Constants/StatusConstant";

export interface StatusOption {
  value: string;
  label: string;
  color: string;
  backgroundColor?: string;
  borderColor?: string;
  textColor?: string;
}

// Enquiry Status Options
export const enquiryStatusOptions: StatusOption[] = [
  { 
    value: ENQ_STATUS.IN_PROGRESS, 
    label: "IN PROGRESS", 
    color: "#FBBD4A",
    backgroundColor: "#FFF6E2",   // softer yellow
    borderColor: "#FBBD4A",
    textColor: "#C98A00"          // slightly darker for readability
  },
  { 
    value: ENQ_STATUS.LOST, 
    label: "LOST", 
    color: "#FF6C6C",
    backgroundColor: "#FFE9E9",   // softer red
    borderColor: "#FF6C6C",
    textColor: "#D64545"
  },
  { 
    value: ENQ_STATUS.CONVERTED, 
    label: "CONVERTED", 
    color: "#0CBA91",
    backgroundColor: "#E6FBF6",   // softer green
    borderColor: "#0CBA91",
    textColor: "#0A8F70"
  },
];

// Quotation Status Options
export const quotationStatusOptions: StatusOption[] = [
  { 
    value: "Prepared", 
    label: "PREPARED", 
    color: "#3F7DDA",
    backgroundColor: "#D3E4F8",
    borderColor: "#3F7DDA",
    textColor: "#3F7DDA"
  },
  { 
    value: "Sent", 
    label: "SENT", 
    color: "#FBBD4A",
    backgroundColor: "#FDE4B4",
    borderColor: "#FBBD4A",
    textColor: "#FBBD4A"
  },
  { 
    value: "Lost", 
    label: "LOST", 
    color: "#FF6C6C",
    backgroundColor: "#FFB2B2",
    borderColor: "#FF6C6C",
    textColor: "#FF6C6C"
  },
  { 
    value: "PO Received", 
    label: "PO RECEIVED", 
    color: "#0CBA91",
    backgroundColor: "#B7FAEB",
    borderColor: "#0CBA91",
    textColor: "#0CBA91"
  },
];

// Sales Order Status Options
export const salesOrderStatusOptions: StatusOption[] = [
  { value: "In Progress", label: "IN PROGRESS", color: "#f59e0b" },
  { value: "follow_up", label: "FOLLOW UP", color: "#17a2b8" },
  { value: "delivered", label: "DELIVERED", color: "#28a745" },
  { value: "pending", label: "PENDING", color: "#ffc107" },
  { value: "shipped", label: "SHIPPED", color: "#6f42c1" },
  { value: "on_hold", label: "ON HOLD", color: "#dc3545" },
];

// Payment management status options
export const paymentManagementStatusOptions: StatusOption[] = [
  { 
    value: "partially_paid", 
    label: "Partially Paid", 
    color: "#FBBD4A",
    backgroundColor: "#FDE4B4",
    borderColor: "#FBBD4A",
    textColor: "#FBBD4A"
  },
  { 
    value: "fully_paid", 
    label: "Fully Paid", 
    color: "#0CBA91",
    backgroundColor: "#B7FAEB",
    borderColor: "#0CBA91",
    textColor: "#0CBA91"
  },
  { 
    value: "paid", 
    label: "Paid", 
    color: "#0CBA91",
    backgroundColor: "#B7FAEB",
    borderColor: "#0CBA91",
    textColor: "#0CBA91"
  },
  { 
    value: "unpaid", 
    label: "Unpaid", 
    color: "#FF6C6C",
    backgroundColor: "#FFB2B2",
    borderColor: "#FF6C6C",
    textColor: "#FF6C6C"
  },
];
